module.exports = __webpack_public_path__ + "static/25-PANAMA.e3d56b80.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/calendar/images/players/25-PANAMA.png
// module id = 720
// module chunks = 35783957827783